/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";

export default function AppDropdown(props) {
  const [displayedData, setDisplayedData] = React.useState([]);
  const [filterInputText, setFilterInputText] = React.useState('');

  const {
    data: initialData,
    onChange: parentOnChange,
    textField,
    dataItemKey,
    ...restProps
  } = props;

  useEffect(() => {
    const source = initialData ? [...initialData] : [];
    if (filterInputText.trim() === '') {
      setDisplayedData(source);
    } else {
      const filterConfig = {
        logic: "or",
        filters: [{
          field: textField || dataItemKey,
          operator: "contains",
          value: filterInputText,
        }],
      };
      setDisplayedData(filterBy(source, filterConfig));
    }
  }, [initialData, filterInputText, textField, dataItemKey]);

  const handleFilterChange = (event) => {
    setFilterInputText(event.filter.value);
  };

  const handleSelectionChange = (event) => {
    if (parentOnChange) {
      parentOnChange(event);
    }
    setFilterInputText('');
  };

  return (
    <DropDownList
      {...restProps}
      filterable
      data={displayedData}
      onFilterChange={handleFilterChange}
      onChange={handleSelectionChange}
      filter={filterInputText}
      textField={textField}
      dataItemKey={dataItemKey}
    />
  );
}